import { useTranslation } from "i18n";
import { SELF_TAPE_FULL_PATH } from "config/common";
import { useNavigate } from "react-router-dom";

export function useGetCancelButton(text?: string) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return {
    text: text ?? t("common:button.label.cancel"),
    onClick: () => navigate(SELF_TAPE_FULL_PATH),
    wrapperClassName: "mr-auto",
  };
}
